import { cx } from "../../lib/cx.js";
import { DialogLayer } from "../_dialog/DialogLayer.js";
/* empty css          */
import { jsx } from "react/jsx-runtime";
//#region src/components/Modal/Modal.tsx
/**
* A modal dialog: the page behind is inert and doesn't scroll, focus is trapped inside
* and returns to where it was on close. Render it where it's used and toggle `open`; it
* portals into the ThemeRoot.
*/
function Modal({ open, onClose, title, description, children, footer, size = "md", dismissable = true, initialFocusRef, "aria-label": ariaLabel, closeLabel = "Close dialog", className, container }) {
	if (!open) return null;
	return /* @__PURE__ */ jsx(DialogLayer, {
		block: "ds-modal",
		panelClassName: cx("ds-modal", `ds-modal--${size}`, className),
		onClose,
		title,
		description,
		footer,
		dismissable,
		initialFocusRef,
		"aria-label": ariaLabel,
		closeLabel,
		container,
		children
	});
}
//#endregion
export { Modal };

//# sourceMappingURL=Modal.js.map